import React, { Component } from 'preact/compat';
import getArticleId from '../../lib/getArticleId';

import transformKeywords from '../../lib/transformKeywords';

export default (ComponentWithKeywords) => {
  class WithKeywords extends Component {
    state = { keywords: [], notInIds: [] };

    async componentWillMount() {
      this.setState({
        keywords: WithKeywords.getKeyworks(),
        notInIds: WithKeywords.getNotInIds(),
      });
    }

    static getKeyworks() {
      const documentKeywords =
        document.querySelectorAll('meta[name="keywords"]');
      const keywords = documentKeywords.length && documentKeywords[0].content;
      return keywords ? transformKeywords(keywords) : [];
    }

    static getNotInIds() {
      const { pathname } = window.location;
      const id = getArticleId(pathname);
      return id ? [id] : [];
    }

    render() {
      return (
        <ComponentWithKeywords
          setKeywords={this.state.keywords}
          setNotInIds={this.state.notInIds}
          {...this.props}
        />
      );
    }
  }

  return WithKeywords;
};
